import getFormattedENumber from './getFormattedENumber'

export default getFormattedENumber
